import { render, staticRenderFns } from "./MatrixSingleChoice.vue?vue&type=template&id=4250de04&scoped=true"
import script from "./MatrixSingleChoice.vue?vue&type=script&lang=js"
export * from "./MatrixSingleChoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4250de04",
  null
  
)

export default component.exports